import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { getProjectById } from '@/services/get-project-by-id'
import { Project } from '@/types/projects'

export const GET_PROJECT_BY_ID = 'project'

type Options = UseQueryOptions<
  Project,
  unknown,
  Project,
  (string | number | undefined)[]
>

export const useGetProjectByID = (
  id: number | undefined,
  options?: Options,
) => {
  const query = useQuery(
    [GET_PROJECT_BY_ID, id],
    ({ signal }) => getProjectById(id!, { signal }),
    {
      enabled: !!id,
      ...options,
    },
  )

  return query
}
